/* eslint-disable no-template-curly-in-string */
export default {
  HRready: 'HRready',
  'Conversation 自测': 'Conversation 自测',
  页面未找到: '页面未找到',
  地推登录: '地推登录',
  地推人员不存在: '地推人员不存在',
  地推邀请码: '地推邀请码',
  地推业绩: '地推业绩',
  招聘者审核详情: '招聘者审核详情',
  用户审核: '用户审核',
  'HRready Invitation': 'HRready 邀请',
  'Campaign rules': '活动细则',
  'HRready User Agreement': 'HRready 用户协议',
  'Privacy Policy': '隐私政策',
  'AI & Automated Services Notice': 'AI 与自动化服务通知',
  'Communications & AI Calls Policy': '通信与 AI 通话政策',
  'California Privacy Notice': '加州隐私声明',
  'Campaign rules | HRready': '活动细则 | HRready',
  'Legal Documents | HRready': '法律文件 | HRready',
  'Privacy Policy | HRready': '隐私政策 | HRready',
  'HRready User Agreement | HRready': 'HRready 用户协议 | HRready',
  'AI & Automated Services Notice | HRready': 'AI 与自动化服务通知 | HRready',
  'Communications & AI Calls Policy | HRready': '通信与 AI 通话政策 | HRready',
  'California Privacy Notice | HRready': '加州隐私声明 | HRready',
  下拉刷新: '下拉刷新',
  释放立即刷新: '释放立即刷新',
  刷新成功: '刷新成功',
  '${name} invited you': '${name} 邀请你加入',
  'Your AI job assistant, always ready': '你的 AI 求职助手，随时准备就绪',
  'Free to register': '免费注册',
  'Always-on matching': '持续匹配',
  'You stay in control': '你始终掌控全局',
  'Referral rewards': '推荐奖励',
  '${amount} EACH': '每人 ${amount}',
  'UP TO ${amount}': '最高 ${amount}',
  '${amount} cash reward for each qualified new job seeker sign-up.':
    '每位符合条件的新求职者完成注册，现金奖励 ${amount}。',
  'AI job assistant': 'AI 求职助手',
  'Your search keeps moving': '持续推进求职进展',
  "The person who invited you can't see your phone number, work history, or applications.":
    '邀请你注册的人无法查看你的手机号、工作经历或投递详情。',
  'Register free and start searching': '免费注册，开始找工作',
  'In as little as ${hours} hours': '最快 ${hours} 小时内',
  '${hours}h': '${hours} 小时',
  'Refer ${count}, get': '推荐 ${count} 人，可得',
  '${amount} per hour': '每小时 ${amount}',
  'in ${hours}h.': '最快 ${hours} 小时。',
  'Paid after registration, verification, and eligibility review. No reward for non-genuine job-search sign-ups, duplicate accounts, or suspicious activity.':
    '完成注册、验证并通过资格审核后发放。非真实求职、重复账号或异常注册不予奖励。',
  'Start in about ${seconds} seconds': '约 ${seconds} 秒即可开始',
  'Create your HRready account': '创建你的 HRready 账号',
  'Close registration': '关闭注册',
  'Invitation relationship connected': '邀请关系已关联',
  'Registration successful': '注册成功',
  'Your account is connected to this invitation. Eligibility and rewards are determined by platform review records.':
    '你的账户已关联本次邀请，后续资格与奖励以平台审核记录为准。',
  'Registration completed normally without an invitation relationship.': '本次已按普通注册完成，未建立邀请关系。',
  'US mobile number': '美国手机号码',
  'Enter your mobile number': '请输入手机号码',
  'Verification code': '验证码',
  'Enter the verification code': '请输入验证码',
  'Enter code': '输入验证码',
  'Send code': '发送验证码',
  'Resend in ${countdown}s': '${countdown}s 后重新发送',
  'Please accept the agreements': '请勾选协议',
  'Failed to load the agreements. Please try again later.': '协议加载失败，请稍后重试',
  'Failed to send the code. Please try again later.': '验证码发送失败，请稍后重试',
  'Verification code sent': '验证码已发送',
  'Send a verification code first': '请先发送验证码',
  'Better jobs, closer to home': '更好的工作，离家更近',
  YOUR: '你的',
  'NEXT PAYCHECK': '下一份薪水',
  'IS CLOSER': '近在眼前',
  'THAN YOU THINK.': '比你想象中更近。',
  'Up to': '最高可达',
  'per hour': '每小时',
  'Get hired in': '最快入职',
  'Close to home': '离家近',
  'walk to work': '步行上班',
  'HRready — your AI job-search assistant.': 'HRready——你的 AI 求职助手。',
  'REGISTER NOW': '立即注册',
  'Get hired': '快速入职',
  'Jobs close to home': '离家近的工作',
  'Find nearby work that fits your schedule': '寻找符合你时间安排的附近工作',
  'Earn more': '赚得更多',
  'Discover better-paying hourly jobs': '发现薪资更高的时薪工作',
  'Fast matching': '快速匹配',
  'Apply once, keep matching': '一次申请，持续匹配',
  'Tell us what you want. AI keeps searching.': '告诉我们你的需求，AI 会持续搜索。',
  'Communicate for you': '代你沟通',
  'Make phone calls and organize information to reduce repetitive filling out and confirmation processes.':
    '拨打电话并整理信息，减少重复填写和确认流程。',
  'Promotion process': '推进流程',
  'Submit job applications, contact candidates, and follow up on interview progress.':
    '提交职位申请、联系候选人并跟进面试进展。',
  "I'll contact you when I need it.": '需要时再联系你',
  'When confirmation or authorization is required, HRready will remind you to proceed.':
    '需要确认或授权时，HRready 会提醒你继续操作。',
  'When confirmation or authorization is required, a card will remind you to proceed.':
    '需要确认或授权时，卡片会提醒你继续操作。',
  'Open HRready': '打开 HRready',
  'Open the app and let AI understand your goals.': '打开应用，让 AI 了解你的目标。',
  'Open the web version or download the app, and select "Find a job" or "Recruit someone".':
    '打开网页版或下载应用，选择“找工作”或“招聘”。',
  'Answer AI calls': '接听 AI 电话',
  'Clearly state the opportunities and preferences.': '清楚说明机会和偏好。',
  'Clearly state the requirements and key conditions.': '清楚说明需求和关键条件。',
  'View progress': '查看进展',
  'Track your applications, interviews, and next steps.': '跟踪申请、面试和后续步骤。',
  'Confirm the application, candidates, and interview arrangements.': '确认申请、候选人和面试安排。',
  'JOB HUNTING\nOR HIRING.\nLEAVE IT TO HRREADY.': '找工作\n或招聘。\n交给 HRREADY。',
  'AI Job Search and Recruitment Assistant': 'AI 求职与招聘助手',
  'iOS Download': 'iOS 下载',
  'Android Download': 'Android 下载',
  'What will HRready\ndo for you?': 'HRready 能为你做什么？',
  'Three steps to begin': '三步开始',
  'Delegate repetitive tasks to HRready, and make the key decisions yourself.':
    '把重复任务交给 HRready，关键决定由你完成。',
  'Every step is recorded and can be viewed or taken over at any time.': '每一步都有记录，可随时查看或接管。',
  'Download APP': '下载 APP',
  地推助手: '地推助手',
  上午好: '上午好',
  工作中: '工作中',
  已暂停: '已暂停',
  入职中: '入职中',
  邀请码: '邀请码',
  业绩: '业绩',
  退出: '退出',
  登录: '登录',
  登录地推工作台: '登录地推工作台',
  登录方式: '登录方式',
  '登录已失效，正在返回登录页': '登录已失效，正在返回登录页',
  '登录中...': '登录中...',
  发送中: '发送中',
  工作邮箱: '工作邮箱',
  欢迎回来: '欢迎回来',
  获取验证码: '获取验证码',
  记住登录状态: '记住登录状态',
  密码: '密码',
  密码登录: '密码登录',
  密码登录账号类型: '密码登录账号类型',
  '密码通过加密连接提交，平台不会展示密码': '密码通过加密连接提交，平台不会展示密码',
  '请输入 4 位验证码': '请输入 4 位验证码',
  请输入密码: '请输入密码',
  请输入手机号: '请输入手机号',
  请输入邮箱: '请输入邮箱',
  请输入正确的邮箱: '请输入正确的邮箱',
  '请输入至少 8 位密码': '请输入至少 8 位密码',
  请先获取验证码: '请先获取验证码',
  使用手机号或邮箱密码登录: '使用手机号或邮箱密码登录',
  使用手机号验证码快速登录: '使用手机号验证码快速登录',
  手机号: '手机号',
  显示密码: '显示密码',
  验证码登录: '验证码登录',
  验证码仅发送至已开通的地推手机号: '验证码仅发送至已开通的地推手机号',
  邮箱: '邮箱',
  隐藏密码: '隐藏密码',
  账号安全保护: '账号安全保护',
  账号或密码错误: '账号或密码错误',
  验证码: '验证码',
  请输入验证码: '请输入验证码',
  '验证码发送失败，请稍后重试': '验证码发送失败，请稍后重试',
  验证码不正确或已失效: '验证码不正确或已失效',
  '登录状态确认失败，请重试': '登录状态确认失败，请重试',
  重新加载: '重新加载',
  二维码: '二维码',
  '二维码包含你的 HRready 地推邀请链接': '二维码包含你的 HRready 地推邀请链接',
  分享邀请码或二维码: '分享邀请码或二维码',
  复制邀请码: '复制邀请码',
  后续进度在业绩页查看: '后续进度在业绩页查看',
  让新用户在注册时填写此邀请码: '让新用户在注册时填写此邀请码',
  扫码使用我的邀请码: '扫码使用我的邀请码',
  推广码展示方式: '推广码展示方式',
  完成注册验证: '完成注册验证',
  我的推广码: '我的推广码',
  '向新用户展示邀请码或二维码，注册时即可关联你的推广来源。':
    '向新用户展示邀请码或二维码，注册时即可关联你的推广来源。',
  新用户注册并通过验证: '新用户注册并通过验证',
  邀请更多用户加入: '邀请更多用户加入',
  邀请码加载中: '邀请码加载中',
  邀请码已复制: '邀请码已复制',
  '邀请码用于提出来源归因，最终业绩以平台验证记录为准。': '邀请码用于提出来源归因，最终业绩以平台验证记录为准。',
  展示推广码: '展示推广码',
  '注册、匹配、面试和结算进度，一部手机随时查看。': '注册、匹配、面试和结算进度，一部手机随时查看。',
  计入业绩进展: '计入业绩进展',
  随时掌握你的: '随时掌握你的',
  'MY PROMOTION CODE': '我的推广码',
  推广码加载失败: '推广码加载失败',
  '请检查网络后重试，当前未切换为手工邀请码。': '请检查网络后重试，当前未切换为手工邀请码。',
  完成普通邀请: '完成普通邀请',
  '当前无活动推广码，不承诺计入活动业绩': '当前无活动推广码，不承诺计入活动业绩',
  '${count} 条': '${count} 条',
  '${value}年': '${value}年',
  '${value}月': '${value}月',
  '${value}日': '${value}日',
  '查看全部 ${count} 条': '查看全部 ${count} 条',
  '查看邀请用户从注册到面试的进度，以及对应结算金额。': '查看邀请用户从注册到面试的进度，以及对应结算金额。',
  从注册到确认面试: '从注册到确认面试',
  待结算: '待结算',
  待结算收入: '待结算收入',
  '待结算收入加载失败，请稍后重试': '待结算收入加载失败，请稍后重试',
  待结算收入加载中: '待结算收入加载中',
  待支付: '待支付',
  当前日期范围内暂无待结算收入: '当前日期范围内暂无待结算收入',
  归属招聘者: '归属招聘者',
  加载中: '加载中',
  取消: '取消',
  结束日期: '结束日期',
  结算概览: '结算概览',
  结算收入与财务回传实时汇总: '结算收入与财务回传实时汇总',
  '结算数据加载失败，请稍后重试': '结算数据加载失败，请稍后重试',
  结算数据加载中: '结算数据加载中',
  开始日期: '开始日期',
  可参与匹配: '可参与匹配',
  累计业绩金额: '累计业绩金额',
  默认最近七天: '默认最近七天',
  全部来源: '全部来源',
  确认: '确认',
  确认面试: '确认面试',
  收起: '收起',
  '数据截至 ${date}': '数据截至 ${date}',
  数据来自结算收入事实与财务付款结果: '数据来自结算收入事实与财务付款结果',
  实时快照: '实时快照',
  我的业绩: '我的业绩',
  下一页: '下一页',
  验证注册: '验证注册',
  业绩概览: '业绩概览',
  业绩区间: '业绩区间',
  '业绩数据加载失败，请稍后重试': '业绩数据加载失败，请稍后重试',
  业务时区: '业务时区',
  已支付累计: '已支付累计',
  '预计解冻 ${date}': '预计解冻 ${date}',
  至: '至',
  注册时间: '注册时间',
  转化进度: '转化进度',
  总金额: '总金额',
  最近进展: '最近进展',
  '操作未完成，请检查网络后重试': '操作未完成，请检查网络后重试',
  创建审核: '创建审核',
  待补充: '待补充',
  待审核: '待审核',
  当前账号没有招聘者审核权限: '当前账号没有招聘者审核权限',
  地推邀请: '地推邀请',
  该招聘者已不在你的当前归属范围内: '该招聘者已不在你的当前归属范围内',
  企业: '企业',
  企业信息待完善: '企业信息待完善',
  全部状态: '全部状态',
  审核: '审核',
  审核不通过: '审核不通过',
  '审核不通过 · 待补充': '审核不通过 · 待补充',
  '审核服务或附件存储暂不可用，请稍后重试': '审核服务或附件存储暂不可用，请稍后重试',
  审核通过: '审核通过',
  审核状态: '审核状态',
  市场: '市场',
  市场待完善: '市场待完善',
  '提交内容不符合要求，请检查后重试': '提交内容不符合要求，请检查后重试',
  提交审核: '提交审核',
  退回补充: '退回补充',
  未分配: '未分配',
  未提供: '未提供',
  邀请: '邀请',
  用户来源: '用户来源',
  资料完善: '资料完善',
  '资料保存、提交和审核决定分别记录，审核只针对已提交版本。':
    '资料保存、提交和审核决定分别记录，审核只针对已提交版本。',
  资料待上传: '资料待上传',
  '资料已被更新，请刷新后重新操作': '资料已被更新，请刷新后重新操作',
  资料已提交审核: '资料已提交审核',
  自然流量: '自然流量',
  返回用户列表: '返回用户列表',
  重试: '重试',
  '第 ${page} / ${totalPages} 页 · 共 ${total} 人': '第 ${page} / ${totalPages} 页 · 共 ${total} 人',
  查看资料: '查看资料',
  '仅展示当前归属招聘者，改派后原负责人立即失去访问权限': '仅展示当前归属招聘者，改派后原负责人立即失去访问权限',
  没有符合筛选条件的招聘者: '没有符合筛选条件的招聘者',
  审核用户分页: '审核用户分页',
  '审核用户加载失败，请检查网络后重试': '审核用户加载失败，请检查网络后重试',
  搜索招聘者: '搜索招聘者',
  上一页: '上一页',
  完善资料: '完善资料',
  '姓名、用户 ID、手机号、企业或市场': '姓名、用户 ID、手机号、企业或市场',
  用户审核筛选: '用户审核筛选',
  招聘者详情: '招聘者详情',
  '正在加载审核用户...': '正在加载审核用户...',
  状态待确认: '状态待确认',
  保存并提交审核: '保存并提交审核',
  保存资料: '保存资料',
  必填: '必填',
  补充说明: '补充说明',
  补充资料要求: '补充资料要求',
  查看审核资料: '查看审核资料',
  当前版本附件: '当前版本附件',
  当前归属: '当前归属',
  '附件不能超过 10 MB': '附件不能超过 10 MB',
  '附件上传失败，请检查文件后重试': '附件上传失败，请检查文件后重试',
  '附件下载失败，请稍后重试': '附件下载失败，请稍后重试',
  '附件已上传，请保存资料以关联到当前版本': '附件已上传，请保存资料以关联到当前版本',
  '每个资料版本最多关联 10 个附件': '每个资料版本最多关联 10 个附件',
  '仅支持 PDF、JPG 和 PNG 文件': '仅支持 PDF、JPG 和 PNG 文件',
  审核版本: '审核版本',
  审核不通过时必填: '审核不通过时必填',
  '审核不通过原因 / 补充要求': '审核不通过原因 / 补充要求',
  '审核决定固定使用已提交版本，不能在本区编辑或替换资料。': '审核决定固定使用已提交版本，不能在本区编辑或替换资料。',
  审核已通过: '审核已通过',
  审核招聘者资料: '审核招聘者资料',
  '审核状态不修改职位状态，仅作为候选端可见性和自动匹配的资格依据。':
    '审核状态不修改职位状态，仅作为候选端可见性和自动匹配的资格依据。',
  审核资料: '审核资料',
  审核资料已保存: '审核资料已保存',
  刷新资料: '刷新资料',
  上传附件: '上传附件',
  '上传中...': '上传中...',
  填写并上传资料: '填写并上传资料',
  '下载 ${filename}': '下载 ${filename}',
  '移除 ${filename}': '移除 ${filename}',
  已提交资料: '已提交资料',
  已退回补充资料: '已退回补充资料',
  用户基础信息: '用户基础信息',
  暂未关联附件: '暂未关联附件',
  暂无审核记录: '暂无审核记录',
  招聘者审核资料: '招聘者审核资料',
  '招聘者审核资料加载失败，请检查网络后重试': '招聘者审核资料加载失败，请检查网络后重试',
  正在加载招聘者资料: '正在加载招聘者资料',
  '支持 PDF、JPG、PNG，单个不超过 10 MB': '支持 PDF、JPG、PNG，单个不超过 10 MB',
  只读审核依据: '只读审核依据',
  '注册于 ${date}': '注册于 ${date}',
  资料: '资料',
  资料版本与审核记录: '资料版本与审核记录',
  资料编号: '资料编号',
  资料名称: '资料名称',
  资料语言: '资料语言',
  最近更新: '最近更新',
  最新资料版本: '最新资料版本',
};
